import React from 'react';

const VideoModal = ({ isOpen, videoUrl, onClose }) => {
  if (!isOpen) return null;

  const renderVideoUrl = () => {
    const videoType = videoUrl.includes('youtube') || videoUrl.includes('youtu.be') ? 'youtube' : 'vimeo';
    let videoId;
    if (videoType === 'youtube') {
      const match = videoUrl.match(/(?:youtube\.com\/(?:shorts\/|(?:v|embed)\/|(?:[^\/]+\/.+\/|.*[?&]v=)|youtu\.be\/))([a-zA-Z0-9_-]{11})/);
      videoId = match ? match[1] : null;
    } else if (videoType === 'vimeo') {
      const match = videoUrl.match(/(?:vimeo\.com\/(?:.*#|.*\/)?([0-9]+))/);
      videoId = match ? match[1] : null;
    }

    if (!videoId) return '';

    return videoType === 'youtube'
      ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1`
      : `https://player.vimeo.com/video/${videoId}?autoplay=1&mute=0&controls=1`;
  };

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal-close" onClick={onClose}>X</button>
        <div style={{ width: '100%', height: '100%' }}>
          <iframe style={{ width: '100%', height: '100%' }} src={renderVideoUrl()} title="Video Player"
            frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;